import React, { useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "./index.css";
import AutocompleteArrow from "../AutocompleteDropdownArrow";

const WaterSupplierAutocomplete = ({
  value,
  chosen,
  setValue,
  onChange,
  disabled = false,
  styleNo = 1,
  edit = true,
  options = [],
  placeholder = "Select or type supplier name",
}) => {
  const divRef = useRef();

  // Use onChange if provided (from CustomTable), otherwise use setValue
  const handleValueChange = onChange || setValue;
  // Use value if provided (from CustomTable), otherwise use chosen
  const currentValue = value || chosen;

  if (!edit) {
    return <h4>{currentValue?.value || currentValue || ""}</h4>;
  }

  return (
    <div className="w-100" ref={divRef}>
      <Autocomplete
        className={`newreact__select__azilis azilis__dropdown__style${styleNo}`}
        freeSolo
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            // User typed a custom value
            handleValueChange({ value: newValue, label: newValue });
          } else if (newValue && newValue.inputValue) {
            // User selected "Add ..." option
            handleValueChange({
              value: newValue.inputValue,
              label: newValue.inputValue,
            });
          } else {
            // User selected from existing options
            handleValueChange(newValue);
          }
        }}
        onInputChange={(event, newInputValue) => {
          // Handle direct input changes
          if (event?.type === "change") {
            handleValueChange({ value: newInputValue, label: newInputValue });
          }
        }}
        filterOptions={(options, params) => {
          const filtered = options.filter((option) =>
            option.label
              ?.toLowerCase()
              .includes(params.inputValue.toLowerCase())
          );

          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some(
            (option) => inputValue === option.label
          );
          if (inputValue !== "" && !isExisting) {
            filtered.push({
              inputValue,
              label: `Add "${inputValue}"`,
              value: inputValue,
            });
          }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        value={currentValue}
        disabled={disabled}
        options={options}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.label || option.value || "";
        }}
        popupIcon={<AutocompleteArrow />}
        renderOption={(props, option) => (
          <li {...props}>
            {option.label?.startsWith("Add ") ? (
              <span style={{ fontStyle: "italic", color: "#666" }}>
                {option.label}
              </span>
            ) : (
              option.label || option.value
            )}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              sx: {
                fontSize: "12px",
                height: "28px",
                padding: "0 8px",
                textAlign: "center",
                "& input": {
                  textAlign: "center",
                  padding: "0",
                  height: "100%",
                },
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#999",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#007bff",
                  borderWidth: "1px",
                },
              },
            }}
            InputLabelProps={{ sx: { fontSize: "12px" } }}
          />
        )}
        componentsProps={{
          paper: { sx: { width: 300 } },
          clearIndicator: {
            sx: {
              color: "#666",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              padding: "2px",
              "& .MuiSvgIcon-root": { fontSize: "14px" },
            },
          },
        }}
        sx={{
          width: "100%",
          "& .MuiAutocomplete-inputRoot": {
            paddingRight: "30px !important",
            minHeight: "28px",
            height: "28px",
          },
          "&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root": {
            paddingRight: "50px !important",
          },
          "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
            {
              paddingRight: "70px !important",
            },
          "& .MuiAutocomplete-popupIndicator": {
            right: "2px",
            top: "50%",
            transform: "translateY(-50%)",
            padding: "2px",
            color: "#666",
          },
          "& .MuiOutlinedInput-root": {
            height: "28px",
            minHeight: "28px",
          },
        }}
      />
    </div>
  );
};

export default WaterSupplierAutocomplete;
